export default __webpack_public_path__ + "static/media/Studies.9ad57699.svg";